export function getReliabilityColor(rate: number | null): string {
  if (rate === null) return 'text-muted-foreground';
  if (rate > 90) return 'text-green-600';
  if (rate >= 70) return 'text-yellow-600';
  return 'text-red-600';
}

export function getSurveyColor(rate: number | null): string {
  if (rate === null) return 'text-muted-foreground';
  if (rate > 80) return 'text-green-600';
  if (rate >= 50) return 'text-yellow-600';
  return 'text-red-600';
}
